// @flow
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import 'client/styles/index.scss';
import App from './App';

type Props = {
	store: any,
};

class Root extends React.PureComponent<Props> {
	render() {
		const { store } = this.props;

		return (
			<Provider store={store}>
				<BrowserRouter>
					<HelmetProvider>
						<App />
					</HelmetProvider>
				</BrowserRouter>
			</Provider>
		);
	}
}

export default Root;
